import { render, staticRenderFns } from "./MaskedText.vue?vue&type=template&id=4f98c81a&scoped=true&"
import script from "./MaskedText.vue?vue&type=script&lang=js&"
export * from "./MaskedText.vue?vue&type=script&lang=js&"
import style0 from "./MaskedText.vue?vue&type=style&index=0&id=4f98c81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f98c81a",
  null
  
)

export default component.exports